import { useContext } from "react"
import { VerNotificacoesFornecedorContext } from "./VerNotificacoesFornecedorContext"

export function useVerNotificacoesFornecedorContext() {
    return useContext(VerNotificacoesFornecedorContext)
}
